import { connect } from 'react-redux'

import TradingChart from '../components/TradingChart'
import { RootState } from '../types'
import { TradingAction, changeSymbol, selectPosition } from '../actions'
import {
  inputPositionSL,
  inputPositionTP,
  inputPositionPrice,
  setPrice,
  setTakeProfit,
  setStopLoss,
} from '../actions/TradeActions'
import { chartReady, setTradingSignal } from '../actions/commonActions'
import { Locale } from '../graphql/schema'
import { getCookie } from '../utils/cookie-utils'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  const locale =
    rootState.appConfig.locale && rootState.appConfig.locale in Locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale

  const chartLocalesMap: any = {
    da: 'da_DK',
    nl: 'nl_NL',
    id: 'id_ID',
    ms: 'ms_MY',
    hi: 'en',
    ph: 'en',
  }

  return {
    symbol: state.symbol,
    signal: state.signal,
    resolution: getCookie('currentResolution') || '30',
    timeframe: '3D',
    type: 1,
    locale: chartLocalesMap[locale] || locale,
    chartMode: state.chartMode,
    positions: Array.from(mt4.positions.values()), // rootState.trades,
    positionsInputs: rootState.positionsInputs,
    pendingOrders: Array.from(mt4.pendingOrders.values()), // rootState.pendingOrders,
    tradingPane: rootState.tradingPane,
    assets: mt4.assets, // rootState.symbolsSubscriptions,
    visibleRange: state.range,
    positionsOpened: state.positionsOpened,
    selectedPosition: state.selectedPosition,
    positionExpanded: state.positionExpanded,
    selectedOrder: state.selectedOrder,
    orderExpanded: state.orderExpanded,
    appTheme: state.appTheme,
    candles: rootState.candles,
    refreshChart: state.refreshChart
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onChangeSymbol: (symbol: string) => dispatch(changeSymbol(symbol)),
    onSetSignal: (signal: any) => dispatch(setTradingSignal(signal)),
    onChartReady: () => dispatch(chartReady()),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
    onInputStopLoss: (order: number, value: number) => dispatch(inputPositionSL(order, value)),
    onInputTakePorfit: (order: number, value: number) => dispatch(inputPositionTP(order, value)),
    onInputPrice: (order: number, value: number) => dispatch(inputPositionPrice(order, value)),
    onSetStopLoss: (value: number) => dispatch(setStopLoss(value)),
    onSetTakePorfit: (value: number) => dispatch(setTakeProfit(value)),
    onSetPrice: (value: number) => dispatch(setPrice(value)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TradingChart)
